var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 81 81",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFF",
    d: "M40.498 80.501C18.406 80.501.497 62.592.497 40.5.497 18.407 18.406.498 40.498.498c22.091 0 40.001 17.909 40.001 40.002 0 22.092-17.91 40.001-40.001 40.001zm25.918-53.022a6.774 6.774 0 00-4.783-4.783c-4.219-1.13-21.135-1.13-21.135-1.13s-16.917 0-21.135 1.13c-2.013.622-4.161 2.455-4.783 4.783-1.131 4.218-1.131 13.021-1.131 13.021s0 8.802 1.131 13.021c.622 2.327 2.77 4.16 4.783 4.782 4.218 1.13 21.135 1.13 21.135 1.13s16.916 0 21.135-1.13a6.774 6.774 0 004.783-4.782c1.13-4.219 1.13-13.021 1.13-13.021s0-8.803-1.13-13.021zM35.88 32.385L49.142 40.5 35.88 48.614V32.385z"
  })));
}

export default SvgYoutube;